<template>
  <div
    class="main"
  >
    <!-- 首页封面 -->
    <self-cover v-if="showIndex" />
    <template v-else>
      <!-- 顶部项目信息 -->
      <top-info />
      <!-- 侧边设置bar -->
      <side-set />
      <!-- 具体页面 -->
      <transition mode="out-in">
        <router-view
          :version="version"
        />
      </transition>
      <!-- 导航 -->
      <nav-bar
        v-if="!isSingle"
        class="nav-bar"
        :nav-info="navInfo"
        :active-nav="activeNav"
        @navChange="navChange"
      />
      <!-- vr带看 -->
      <vr-appoint :contacts-info="[]" />
    </template>
    <!-- 背景音乐 -->
    <audio
      id="music"
      autoplay="autoplay"
      loop
      preload
      hidden
    >
      <source src="https://gemdale-green.oss-cn-beijing.aliyuncs.com/xinyi/bgm.mp3">
    </audio>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar';
import VrAppoint from '@/components/VrAppoint';
import selfCover from '@/pages/index/cover';
import { NAV_INFO, PRE_LOAD_IMGS, CONTACTS_INFO } from '@/libs/config/index';
// import { getConfig } from '@/libs/api';
import { Popup } from 'vant';
import TopInfo from '@/components/TopInfo';
import SideSet from '@/components/SideSet';
import { wexinShare } from '@/libs/util';
import { getWeChatSignature } from '@/libs/api';

export default {
  components: {
    selfCover,
    NavBar,
    VrAppoint,
    TopInfo,
    SideSet,
    [Popup.name]: Popup,
  },
  data() {
    return {
      contactsInfo: CONTACTS_INFO,
      showIndex: true,
      navInfo: NAV_INFO,
      activeNav: NAV_INFO[0].name,

      version: '',
      showContacts: false,

      isSingle: false, // 不需要导航
    };
  },
  watch: {
    activeNav(name) {
      if (name) {
        this.scrollIntoView(name);
      }
    },
  },
  async created() {
    // 设置正确的初始路由
    setTimeout(() => {
      this.activeNav = this.$route.name;
    }, 100);
  },
  mounted() {
    this.preload();
    setTimeout(() => {
      this.showIndex = false;
    }, 4000);
    // 设置正确的初始路由
    setTimeout(() => {
      this.activeNav = this.$route.name;
    }, 100);
    // 自动播放
    // 需要分享打开
    this.wxShareInit();
  },
  methods: {
    navChange(name) {
      if (this.$route.name !== name) {
        this.activeNav = name;
        this.$router.push({ name });
      }
    },
    preload() {
      const list = PRE_LOAD_IMGS;
      for (const img of list) {
        const image = new Image();
        image.src = img;
        image.onload = () => {
        };
      }
    },
    scrollIntoView(id) {
      this.$nextTick(() => {
        document.getElementById(`nav-${id}`).scrollIntoView({ behavior: 'smooth' });
      });
    },

    // 微信分享
    wxShareInit() {
      // 请求微信配置参数接口（获取签名），由后台给接口给
      const url = window.location.href.split('#')[0];
      // 看后台请求接口是get/post
      getWeChatSignature({ url }).then((res) => {
        const {
          return_data: { signature, timestamp },
        } = res;
          // 微信加签
        const obj = {
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          timestamp, // 必填，生成签名的时间戳
          signature, // 必填，签名
        };
        const shareData = {
          link: url,
        };
        // 引用
        wexinShare(obj, shareData);
      });
    },
  },
};
</script>

<style lang="less" scope>
.v-enter{
  opacity: 0;
}
.v-enter-active{
  transition: 0.5s;
}
.v-enter-to{
  opacity: 1;
}
.v-leave{
  opacity: 1;
}
.v-leave-to{
  opacity:0;
}
.v-leave-active{
  transition: 0.5s;
}
.main {
  position: relative;
  width: 10rem;
  height: 100vh;
  background-image: url('../../imgs/index/bg.png');
  background-color: #171717;
  background-size: cover;
  background-position: 100%;
  .audio-icon {
    position: fixed;
    top: 64px;
    right: 0.4rem;
  }
  .nav-bar {
    position: absolute;
    width: 10rem;
    height: 54px;
    bottom: 0;
    left: 0;
    z-index: 2001;
    background-image: url('../../imgs/index/nav/nav_bg.png');
    background-size: 100% 100%;
  }
  .index-bg {
    position: relative;
    width: 100%;
    height: 100%;
    background: #000000;
    background-size: cover;
    background-position: 100%;
    z-index: 101;
    .main-img {
      margin-top: -5vh;
    }
    .logo-tag {
      position: absolute;
      bottom: 0;
    }
  }
}
</style>
